import { Component } from "@angular/core";

@Component({
  selector: "page-content",
  standalone: true,
  templateUrl: "./page-content.component.html",
  styleUrls: ["./page-content.component.scss"],
})
export class PageContentComponent {}
